export class ReadTimeEstimator {
    private wpm: number;

    constructor(wpm: number = 150) {
        this.wpm = wpm;
    }

    private countWords(text: string): number {
        const words: RegExpMatchArray | null = text.match(/\b\w+\b/g);
        return words ? words.length : 0;
    }

    public countWordsFromInputs(): number {
        const elements = document.querySelectorAll<HTMLElement>('[data-readtime-input]');
        let totalWords = 0;

        elements.forEach(el => {
            const text: string = el.textContent || el.innerText || "";
            totalWords += this.countWords(text);
        });

        return totalWords;
    }

    public getReadTimeInMinutes(wordCount: number): number {
        const minutes: number = wordCount / this.wpm;
        return Math.ceil(minutes);
    }

    public estimate(): { wordCount: number; readTime: number } {
        const wordCount = this.countWordsFromInputs();
        const readTime = this.getReadTimeInMinutes(wordCount);
        console.log(wordCount);
        return { wordCount, readTime };
    }

    public updateReadTimeElements(): void {
        const { readTime } = this.estimate();
        const outputElements = document.querySelectorAll<HTMLElement>('[data-readtime-output]');

        outputElements.forEach(el => {
            el.textContent = `${readTime}`;
        });
    }
}